import type { TypedClient } from '@platform/openapi';
import { useState } from 'react';
import { productIdsOf, useCodeLookup } from '../useCodeLookup.ts';
import type { ProductFilters } from './product-filters.ts';

export type CodeSearchInput = {
  readonly api: TypedClient;
  readonly filters: ProductFilters;
  readonly onFiltersChange: (filters: ProductFilters) => void;
  readonly onOpenProduct: (productId: string) => void;
};

export const useCodeSearch = ({ api, filters, onFiltersChange, onOpenProduct }: CodeSearchInput) => {
  const lookup = useCodeLookup(api);
  const [boxKey, setBoxKey] = useState(0);
  const searchAsText = (text: string) => {
    const search = text.trim() === '' ? null : text.trim();
    if (search !== filters.search) onFiltersChange({ ...filters, search });
  };
  const openScanned = (productId: string) => {
    setBoxKey((key) => key + 1);
    if (filters.search !== null) onFiltersChange({ ...filters, search: null });
    onOpenProduct(productId);
  };
  const search = async (text: string) => {
    const term = text.trim();
    if (term === '' || term === filters.search) {
      searchAsText(term);
      return;
    }
    const [productId, ...others] = productIdsOf(await lookup(term).catch(() => []));
    if (productId === undefined || others.length > 0) searchAsText(term);
    else openScanned(productId);
  };
  return {
    boxKey,
    searchAsText,
    search: (text: string) => {
      void search(text);
    },
  };
};
